module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-page', {
    staticClass: "l-content l-projet"
  }, [_c('custom-toolbar', {
    attrs: {
      "backLabel": "Retour"
    }
  }, [_vm._v(_vm._s(_vm.$t("Mon projet")))]), _vm._v(" "), (_vm.project != null) ? _c('div', [_c('div', {
    staticClass: "projetPicture",
    style: ({
      backgroundImage: 'url(' + _vm.project_background + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "projetInfos"
  }, [_c('div', {
    staticClass: "infoContent"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v(_vm._s(_vm.projectType(_vm.project)) + " : " + _vm._s(_vm.project.type) + ", " + _vm._s(_vm.project.ref) + " (" + _vm._s(_vm.project.promoteur) + ")")])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "grid"
  }, _vm._l((_vm.project.pictures), function(image, key) {
    return _c('div', {
      key: key,
      staticClass: "picture",
      style: ({
        backgroundImage: 'url(' + _vm.project_pictures_url + '/preview/' + image.filename + ')'
      }),
      on: {
        "click": function($event) {
          return _vm.toggleGallery(true, key)
        }
      }
    })
  }), 0)])]), _vm._v(" "), _c('v-ons-modal', {
    staticClass: "l-modal gallery",
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "visible": _vm.galleryVisible
    }
  }, [_c('i', {
    staticClass: "fa fa-times close_btn",
    on: {
      "click": function($event) {
        _vm.galleryVisible = false
      }
    }
  }), _vm._v(" "), _c('v-ons-carousel', {
    attrs: {
      "fullscreen": "",
      "swipeable": "",
      "auto-scroll": "",
      "overscrollable": "",
      "index": _vm.galleryIndex
    },
    on: {
      "update:index": function($event) {
        _vm.galleryIndex = $event
      }
    }
  }, _vm._l((_vm.project.pictures), function(image, key) {
    return _c('v-ons-carousel-item', {
      key: key
    }, [_c('div', {
      staticClass: "carousel-item-wrapper"
    }, [_c('img', {
      attrs: {
        "src": _vm.project_pictures_url + '/' + image.filename
      }
    })])])
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.project == null) ? _c('div', [_vm._v("\n    " + _vm._s(_vm.$t("Aucun projet pour l'instant")) + "\n  ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9403b1f6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Project.vue
// module id = 235
// module chunks = 0